e.M.single = {
	init : function(){
		if( $( '.my-classes-single' ).length ){
			this._maybe_trigger_modal();
			this._init_clipboard();
		}

	},

	_init_clipboard: function(){
		var join_url = $( '[data-js="edspire/my-classes/join-url"]' );
		if( join_url.length ){
			var clip = new Clipboard( join_url.get(0) );
			clip.on( 'success', function( e ){
				join_url.text( 'Copied' );
				join_url.addClass( 'copied' );
			}.bind( this ) );
		}
	},

	_maybe_trigger_modal : function(){
		if( typeof( $_GET[ config.my_classes_trigger_edit_modal ] ) !== "undefined" ){
			$( '.class-edit-settings i').click();
		}
	}

};